module.exports = {"450721001":"灵城街道","450721002":"三海街道","450721101":"新圩镇","450721102":"丰塘镇","450721103":"平山镇","450721104":"石塘镇","450721105":"佛子镇","450721106":"平南镇","450721107":"烟墩镇","450721108":"檀圩镇","450721109":"那隆镇","450721110":"三隆镇","450721111":"陆屋镇","450721112":"旧州镇","450721113":"太平镇","450721114":"沙坪镇","450721115":"武利镇","450721116":"文利镇","450721117":"伯劳镇","450721400":"国营新光农场","450721401":"国营华山农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450721.json
// module id = 1952
// module chunks = 0